import { useState, useEffect, forwardRef } from 'react';
import PropTypes from 'prop-types';
import styledComponents from "styled-components";

import {
  Box,
  Divider,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Typography,
  TextField,
  Button,
  Menu,
  MenuItem,
  ListItemIcon,
  Modal,
  InputBase,
  InputLabel,
  IconButton,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Pagination,
  Select,
  Stack,
  Snackbar,
  Paper
} from "@mui/material";
import MuiAlert from '@mui/material/Alert';

import axios from  "axios";
import { Formik } from 'formik';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import DeleteIcon from '@mui/icons-material/Delete';
import SearchIcon from '@mui/icons-material/Search';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: { xs: '80%', md: 400 },
  maxHeight: '66vh',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  overflow: 'scroll'
};

const Container = styledComponents.div`
    padding: 20px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
`;

const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Pricelist = () => {
    
    const [page, setPage] = useState({ value: 1 });
    const [pageInfo, setPageInfo] = useState(null);
    const [pageSize, setPageSize] = useState({ value: 24 });

    const [data, setData] = useState([]);
    const [search, setSearch] = useState(null);
    const [authData, setAuth] = useState(null);

    const handlePage = (event, value) => {
        setPage({ value });
        const serviceToken = window.localStorage.getItem('serviceToken');
        const getData = async () => {
            try {
              const pricelist = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/pricelist`, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                },
                params: {
                    namaproduk: search,
                    page: value,
                    perPage: pageSize.value
                }
            });
              let number = (value - 1) * (pageSize.value);
              setData(pricelist.data.result.data.map((v) => {
                number+=1;
                return { ...v, no: number };
              }));
              const pageInfoRes = Object.keys(pricelist.data.result)
                  .filter((key) => {
                      if (key !== 'data') return true;
                      return false;
                  })
                  .reduce((cur, key) => Object.assign(cur, { [key]: pricelist.data.result[key] }), {});
              setPageInfo(pageInfoRes);
            } catch (err) {
                console.error(err);
            }
        };
        getData();
    };

    useEffect(() => {
        const getData = async () => {
            try {
                const pricelist = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/pricelist`, {
                    headers: {
                        Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                    },
                    params: {
                        page: page.value,
                        perPage: pageSize.value
                    }
                });
                let number = 0;
                setData(pricelist.data.result.data.map((v) => {
                    number+=1;
                    return { ...v, no: number };
                }));
                const pageInfoRes = Object.keys(pricelist.data.result)
                    .filter((key) => {
                        if (key !== 'data') return true;
                        return false;
                    })
                    .reduce((cur, key) => Object.assign(cur, { [key]: pricelist.data.result[key] }), {});
                setPageInfo(pageInfoRes);
            } catch (err) {
                console.log(err);
            }
        };
        const auth = async () => {
            try {
                const me = await axios.get(`${process.env.REACT_APP_API_URL}/api/auth/me`,
                  {
                    headers: {
                        Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                    }
                  }
                );
                setAuth(me.data.result);
            } catch (err) {
              console.log(err);
    
            }
        };
        auth();
        getData();
    }, [])

    return (
        <Container>
            <Grid container spacing={2}>
                <Grid item xs={12} sx={{ margin: '10px 14px'}}>
                    <Typography variant="h5" fontWeight="700">Pricelist</Typography>
                </Grid>
            </Grid>
            <Grid item xs={12} my={1}>
                <Formik
                    initialValues={{ namaproduk: null }}
                    validate={async (values) => {
                        const errors = {};
                        if (!values.namaproduk) {
                            errors.namaproduk = 'Required';
                        }
                        if (values.namaproduk === '') {
                            setSearch(null);
                            try {
                                setPage({ value: 1 });
                                const pricelist = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/pricelist`, {
                                    headers: {
                                        Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                                    },
                                    params: {
                                        page: 1,
                                        perPage: pageSize.value
                                    }
                                });
                                let number = 0;
                                setData(pricelist.data.result.data.map((v) => {
                                    number+=1;
                                    return { ...v, no: number };
                                }));
                                const pageInfoRes = Object.keys(pricelist.data.result)
                                    .filter((key) => {
                                        if (key !== 'data') return true;
                                        return false;
                                    })
                                    .reduce((cur, key) => Object.assign(cur, { [key]: pricelist.data.result[key] }), {});
                                setPageInfo(pageInfoRes);
                            } catch (err) {
                                console.log(err);
                            }
                        }
                        return errors;
                    }}
                    onSubmit={async (values, { setSubmitting }) => {
                        setPage({ value: 1 });
                        try {
                            const pricelist = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/pricelist`, {
                                headers: {
                                    Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                                },
                                params: {
                                    namaproduk: values.namaproduk,
                                    page: 1,
                                    perPage: pageSize.value
                                }
                            });
                            let number = 0;
                            setData(pricelist.data.result.data.map((v) => {
                                number+=1;
                                return { ...v, no: number };
                            }));
                            setSearch(values.namaproduk);
                            const pageInfoRes = Object.keys(pricelist.data.result)
                                .filter((key) => {
                                    if (key !== 'data') return true;
                                    return false;
                                })
                                .reduce((cur, key) => Object.assign(cur, { [key]: pricelist.data.result[key] }), {});
                            setPageInfo(pageInfoRes);
                            setSubmitting(false);
                        } catch (err) {
                            console.log(err);
                        }
                    }}
                >
                    {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                        /* and other goodies */
                    }) => (
                        <form onSubmit={handleSubmit} style={{ width: '100%' }}>
                            <Paper
                            component="div"
                            sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: {xs: '100%', md: '50%'}}}
                            >
                            <InputBase
                                sx={{ ml: 1, flex: 1 }}
                                required
                                name="namaproduk"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                placeholder="Cari produk"
                                inputProps={{ 'aria-label': 'cari produk' }}
                            />
                            <IconButton type="submit" sx={{ p: '10px' }} aria-label="search">
                                <SearchIcon />
                            </IconButton>
                            </Paper>
                        </form>
                    )}
                </Formik>
            </Grid>
            <TableContainer component={Paper} sx={{ maxHeight: {xs: '70vh', sm: 740, md: 800} }}>
                <Table stickyHeader aria-label="sticky table" sx={{ minWidth: 700 }}>
                    <TableHead>
                        <TableRow>
                            <TableCell><Typography variant="subtitle2" fontWeight="700">No</Typography></TableCell>
                            <TableCell><Typography variant="subtitle2" fontWeight="700">Nama Produk</Typography></TableCell>
                            <TableCell><Typography variant="subtitle2" fontWeight="700">Harga Konsumen</Typography></TableCell>
                            {authData !== null && authData.role === 'distributor' && (
                                <TableCell><Typography variant="subtitle2" fontWeight="700">Harga Distributor</Typography></TableCell>
                            )}
                            {authData !== null && (authData.role === 'distributor' || authData.role === 'agen') && (
                                <TableCell><Typography variant="subtitle2" fontWeight="700">Harga Agen</Typography></TableCell>
                            )}
                            {authData !== null && (authData.role === 'distributor' || authData.role === 'agen' || authData.role === 'reseller') && (
                                <TableCell><Typography variant="subtitle2" fontWeight="700">Harga Reseller</Typography></TableCell>
                            )}
                            <TableCell><Typography variant="subtitle2" fontWeight="700">Harga Marketer</Typography></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                    {data.map((row) => (
                        <TableRow
                            key={row.idharga}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                            <TableCell>{row.no}</TableCell>
                            <TableCell>{row.namaartikel}</TableCell>
                            <TableCell align="right">Rp {row.harga_ecer_d.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</TableCell>
                            {authData !== null && authData.role === 'distributor' && (
                                <TableCell align="right">Rp {row.harga_d.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</TableCell>
                            )}
                            {authData !== null && (authData.role === 'distributor' || authData.role === 'agen') && (
                                <TableCell align="right">Rp {row.harga_a.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</TableCell>
                            )}
                            {authData !== null && (authData.role === 'distributor' || authData.role === 'agen'|| authData.role === 'reseller') && (
                                <TableCell align="right">Rp {row.harga_ecer_a.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</TableCell>
                            )}
                            <TableCell align="right">Rp {row.harga_marketer.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</TableCell>
                        </TableRow>
                    ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <Grid item xs={12} my={1}>
                <Stack spacing={0}>
                    <Pagination
                        count={pageInfo ? pageInfo.last_page : 10}
                        color="primary"
                        page={page.value}
                        onChange={handlePage}
                        variant="outlined"
                        shape="rounded"
                    />
                </Stack>
            </Grid>
        </Container>
    )
}

export default Pricelist;
